import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import {
  BiContextProvidedValue,
  BiData,
  DefaultBiEvent,
} from '@wix/da-bi/pkg/events';
import { useBiClickLogger } from '@wix/da-bi/pkg/hooks/useBiClickLogger';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';

interface Props {
  filterValue: string;
  className?: string;
  onFilterInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const GroupSearchInput: React.FC<Props> = ({
  filterValue,
  onFilterInputChange,
  className,
}) => {
  const { t } = useTranslation();
  const { setTrackingRef: setInputRef } = useBiClickLogger(
    BiData<DefaultBiEvent>({
      evid: 2,
      click_info: 'addToGroup.searchGroup',
      sectionname: BiContextProvidedValue,
      widgetname: BiContextProvidedValue,
      typeid: BiContextProvidedValue,
      itemid: BiContextProvidedValue,
    })
  );
  return (
    <TextInput
      ref={setInputRef}
      id="search-input"
      className={className}
      label={t('addToGroupPopup.input.filter.placeholder')}
      placeholder={t('addToGroupPopup.input.filter.placeholder')}
      value={filterValue}
      onChange={onFilterInputChange}
      prefix={<SearchIcon disableDefaultColors />}
      noBottomSpacing
      isLabelHidden
    />
  );
};
GroupSearchInput.displayName = 'GroupSearchInput';

export default GroupSearchInput;
